import React from 'react';
import Slider from 'react-slick';
import { Box, Card, CardContent, CardMedia, Typography, IconButton, Tooltip } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../style/home.css';
import '../style/common.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import defaultImage from '../assets/brand-logo.jpg'

const CardCarousel = ({charityData}) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <IconButton onClick={onClick} style={{ position: 'absolute', top: '45%', right: '0px', zIndex: 2,  background:  '#123261' }}>
        <ArrowForwardIosIcon style={{ color: "#fff", width: 18, height: 18 }}/>
      </IconButton>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <IconButton onClick={onClick} style={{ position: 'absolute', top: '45%', left: '0px', zIndex: 2, background:  '#123261' }}>
        <ArrowBackIosIcon style={{ color: "#fff",  paddingLeft: 5 }}/>
      </IconButton>
    );
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

const getFileTypeFromUrl = (url) => {
    const splitArray = url.split('.');
    const lastPart = splitArray[splitArray.length - 1];
    const textBeforeQuestionMark = lastPart.split('?')[0].toLowerCase();;

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp',  'svg', 'jfif', 'tiff'];
    const videoExtensions = ['mp4', 'webm', 'ogg', 'mkv', 'avi', 'mov', 'flv'];

    if (imageExtensions.includes(textBeforeQuestionMark)) {
        return 'image';
    } else if (videoExtensions.includes(textBeforeQuestionMark)) {
        return 'video';
    } else {
        return 'unknown'; // or handle other types as needed
    }
}

  return (
    <Box sx={{ maxWidth: '100%' }}>
      <Slider {...settings}>
        {charityData?.map((card, index) => (
          <Box key={index}  sx={{ padding: '0 20px', cursor: 'pointer' }} onClick={() => {
            // if((card?.filePreSignedUrl)) {
              navigate('/view-charitable-activity/'+card?.id);
            // }
          }}>
            <Card sx={{ margin: '0 auto', boxShadow: 3, height: 'auto' }} className="eventCard">
              <Box sx={{ position: 'relative', height: '265px' }} >
                {(!card?.filePreSignedUrl) ? (
                  // <Box
                  //   sx={{
                  //     width: '100%',
                  //     height: '100%',
                  //     display: 'flex',
                  //     alignItems: 'center',
                  //     justifyContent: 'center',
                  //     backgroundColor: '#f0f0f0'
                  //   }}
                  // >
                  //   <Typography variant="body2" color="text.secondary">
                  //     {t('No Media Available')}
                  //   </Typography>
                  // </Box>
                  <CardMedia
                        component="img"
                        height="100%"
                        image={defaultImage}
                        alt={`Card ${index + 1}`}
                        style={{objectFit: 'contain',padding: '10px'}}
                        // sx={{ objectFit: 'contain' }}
                      />
                ) : (
                  (() => {
                    const mediaUrl = card?.filePreSignedUrl;
                    const mediaType = getFileTypeFromUrl(mediaUrl);

                    return mediaType === 'image' ? (
                      <CardMedia
                        component="img"
                        height="100%"
                        image={mediaUrl}
                        alt={`Card ${index + 1}`}
                        sx={{ objectFit: 'cover' }}
                      />
                    ) : (
                      <CardMedia
                        component="video"
                        height="100%"
                        src={mediaUrl}
                        controls
                        sx={{ objectFit: 'cover' }}
                      />
                    );
                  })()
                )}
                <Tooltip title={card.activityName} arrow>
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      backgroundColor: '#000000',
                      color: '#fff',
                      padding: '4px 8px',
                      borderRadius: '5px',
                      fontSize: 14,
                      fontWeight: 800,
                      maxWidth: '200px',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {card.charityName}
                  </Box>
                </Tooltip>
              </Box>
              <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '280px' }}>
                <Box sx={{ flex: '1', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <Typography gutterBottom variant="h5" component="div" style={{ fontSize: 14, display: 'flex', alignItems: 'center', gap: 10, marginBottom: 25 }}>
                    <CalendarMonthIcon style={{ color: "#05AAE8", width: 18, height: 18 }} /> {card.eventStartDate}
                  </Typography>
                  <Typography gutterBottom variant="h5" component="div" style={{ fontSize: 24, marginBottom: 25 }}>
                    {card.eventName}
                  </Typography>
                  <div className='gradientDivider'></div>
                  <Typography gutterBottom variant="h5" component="div" style={{ fontSize: 14, display: 'flex', alignItems: 'center', gap: 10, marginBottom: 25 }}>
                    <LocationOnIcon style={{ color: "#05AAE8", width: 18, height: 18 }} /> {card.businessUnitLocationName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {card.address}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default CardCarousel;
